<ng-container *ngIf="formGroup" [formGroup]="formGroup">

    <mat-form-field class="form-field">
        <mat-label>
            {{label}}
        </mat-label>
        <input formControlName="filter" matInput [matAutocomplete]="autoComplete">
        <button mat-icon-button matSuffix (click)="setLocation(null)" *ngIf="editMode">
            <mat-icon>clear</mat-icon>
        </button>
        <mat-autocomplete class="edit-view-auto-complete" #autoComplete="matAutocomplete"
            [displayWith]="display.bind(this)">
            <div *ngFor="let location of dataService.locations">
                <mat-option *ngIf="matchesFilter(location)" [value]="location.locationid" (click)="setLocation(location.locationid)">
                    {{display(location.locationid)}}
                </mat-option>
            </div>
        </mat-autocomplete>
        <div *ngIf="showCurrentValues && containsChanges" class="old-value"
            matTooltip="Klicken um Wert zurückzusetzen" (click)="resetValue()">
            Alter Standort:
            <span *ngIf="presetted; else nullValue">
                {{display(presetted)}}
            </span>
        </div>
    </mat-form-field>

    <ng-template #nullValue>
        <span class="null-value">kein Wert</span>
    </ng-template>

</ng-container>